import React, { useState } from 'react';
import { useAdminTheme } from '../contexts/AdminThemeContext';
import Icon from './AppIcon';

const AboutContentManagement = () => {
  const { currentColors } = useAdminTheme();
  const [activeSection, setActiveSection] = useState('vision');

  // Vision Document Management
  const [visionDoc, setVisionDoc] = useState({
    title: 'Vision Document 2024',
    description: 'Strategic roadmap for global expansion',
    file_url: '',
    file_name: ''
  });

  // Strategic Consultation Management
  const [consultation, setConsultation] = useState({
    provider: 'microsoft',
    microsoft_booking_url: '',
    calendly_url: '',
    description: 'Schedule a strategic consultation with our experts',
    auto_approval: true
  });

  // Company Info Management
  const [companyInfo, setCompanyInfo] = useState({
    company_description: '',
    mission_statement: '',
    vision_statement: '',
    founding_year: '',
    headquarters: ''
  });

  const sections = [
    { id: 'vision', label: 'Vision Document', icon: 'FileText' },
    { id: 'consultation', label: 'Strategic Consultation', icon: 'Calendar' },
    { id: 'company-info', label: 'Company Information', icon: 'Building' }
  ];

  const saveVisionDocument = () => {
    alert('Vision document saved successfully!');
  };

  const saveConsultationSettings = () => {
    alert('Consultation settings saved successfully!');
  };

  const saveCompanyInfo = () => {
    alert('Company information saved successfully!');
  };

  const renderVisionDocument = () => (
    <div className="space-y-6">
      <div className="p-6 rounded-lg border" style={{ backgroundColor: currentColors.surface, borderColor: currentColors.border }}>
        <h3 className="text-lg font-semibold mb-4" style={{ color: currentColors.text }}>
          Vision Document Management
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Document Title
            </label>
            <input
              type="text"
              value={visionDoc.title}
              onChange={(e) => setVisionDoc({...visionDoc, title: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
              placeholder="Enter document title"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Description
            </label>
            <textarea
              value={visionDoc.description}
              onChange={(e) => setVisionDoc({...visionDoc, description: e.target.value})}
              rows={3}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
              placeholder="Brief description of the vision document"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Document URL
            </label>
            <input
              type="url"
              value={visionDoc.file_url}
              onChange={(e) => setVisionDoc({...visionDoc, file_url: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
              placeholder="https://example.com/vision-document.pdf"
            />
          </div>

          {visionDoc.file_url && (
            <div className="p-4 rounded-lg" style={{ backgroundColor: `${currentColors.primary}10` }}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Icon name="FileText" size={20} style={{ color: currentColors.primary }} />
                  <div>
                    <p className="font-medium" style={{ color: currentColors.text }}>{visionDoc.title}</p>
                    <p className="text-sm" style={{ color: currentColors.textMuted }}>
                      Document URL provided
                    </p>
                  </div>
                </div>
                <a
                  href={visionDoc.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 rounded-lg font-medium transition-all duration-200"
                  style={{
                    backgroundColor: currentColors.primary,
                    color: '#ffffff'
                  }}
                >
                  Preview
                </a>
              </div>
            </div>
          )}

          <button
            onClick={saveVisionDocument}
            className="px-6 py-2 rounded-lg font-medium transition-all duration-200"
            style={{
              backgroundColor: currentColors.primary,
              color: '#ffffff'
            }}
          >
            Save Vision Document
          </button>
        </div>
      </div>
    </div>
  );

  const renderConsultation = () => (
    <div className="space-y-6">
      <div className="p-6 rounded-lg border" style={{ backgroundColor: currentColors.surface, borderColor: currentColors.border }}>
        <h3 className="text-lg font-semibold mb-4" style={{ color: currentColors.text }}>
          Strategic Consultation Settings
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Booking Provider
            </label>
            <select
              value={consultation.provider}
              onChange={(e) => setConsultation({...consultation, provider: e.target.value})}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
            >
              <option value="microsoft">Global Technology Leader Booking</option>
              <option value="calendly">Calendly</option>
            </select>
          </div>

          {consultation.provider === 'microsoft' && (
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Global Technology Leader Booking URL
              </label>
              <input
                type="url"
                value={consultation.microsoft_booking_url}
                onChange={(e) => setConsultation({...consultation, microsoft_booking_url: e.target.value})}
                placeholder="https://outlook.live.com/owa/calendar/..."
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
              />
            </div>
          )}

          {consultation.provider === 'calendly' && (
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Calendly URL
              </label>
              <input
                type="url"
                value={consultation.calendly_url}
                onChange={(e) => setConsultation({...consultation, calendly_url: e.target.value})}
                placeholder="https://calendly.com/..."
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Description
            </label>
            <textarea
              value={consultation.description}
              onChange={(e) => setConsultation({...consultation, description: e.target.value})}
              rows={3}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
              placeholder="Description of the consultation service"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={consultation.auto_approval}
              onChange={(e) => setConsultation({...consultation, auto_approval: e.target.checked})}
            />
            <span style={{ color: currentColors.text }}>Auto-approve booking requests</span>
          </div>

          <button
            onClick={saveConsultationSettings}
            className="px-6 py-2 rounded-lg font-medium transition-all duration-200"
            style={{
              backgroundColor: currentColors.primary,
              color: '#ffffff'
            }}
          >
            Save Consultation Settings
          </button>
        </div>
      </div>
    </div>
  );

  const renderCompanyInfo = () => (
    <div className="space-y-6">
      <div className="p-6 rounded-lg border" style={{ backgroundColor: currentColors.surface, borderColor: currentColors.border }}>
        <h3 className="text-lg font-semibold mb-4" style={{ color: currentColors.text }}>
          Company Information
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
              Company Description
            </label>
            <textarea
              value={companyInfo.company_description}
              onChange={(e) => setCompanyInfo({...companyInfo, company_description: e.target.value})}
              rows={4}
              className="w-full px-3 py-2 border rounded-lg"
              style={{
                backgroundColor: currentColors.background,
                borderColor: currentColors.border,
                color: currentColors.text
              }}
              placeholder="Brief description of your company"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Mission Statement
              </label>
              <textarea
                value={companyInfo.mission_statement}
                onChange={(e) => setCompanyInfo({...companyInfo, mission_statement: e.target.value})}
                rows={3}
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
                placeholder="Your company's mission statement"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Vision Statement
              </label>
              <textarea
                value={companyInfo.vision_statement}
                onChange={(e) => setCompanyInfo({...companyInfo, vision_statement: e.target.value})}
                rows={3}
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
                placeholder="Your company's vision statement"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Founding Year
              </label>
              <input
                type="number"
                value={companyInfo.founding_year}
                onChange={(e) => setCompanyInfo({...companyInfo, founding_year: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
                placeholder="e.g., 2020"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                Headquarters
              </label>
              <input
                type="text"
                value={companyInfo.headquarters}
                onChange={(e) => setCompanyInfo({...companyInfo, headquarters: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border,
                  color: currentColors.text
                }}
                placeholder="e.g., Bengaluru, Karnataka"
              />
            </div>
          </div>

          <button
            onClick={saveCompanyInfo}
            className="px-6 py-2 rounded-lg font-medium transition-all duration-200"
            style={{
              backgroundColor: currentColors.primary,
              color: '#ffffff'
            }}
          >
            Save Company Information
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="p-6" style={{ backgroundColor: currentColors.background }}>
      <div className="mb-6">
        <h2 className="text-2xl font-bold" style={{ color: currentColors.text }}>
          About Us Content Management
        </h2>
        <p style={{ color: currentColors.textMuted }}>
          Manage all About Us page content and settings
        </p>
      </div>

      {/* Section Tabs */}
      <div className="flex gap-2 mb-6 border-b" style={{ borderColor: currentColors.border }}>
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => setActiveSection(section.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-t-lg transition-all duration-200 ${
              activeSection === section.id ? 'border-b-2' : ''
            }`}
            style={{
              borderColor: activeSection === section.id ? currentColors.primary : 'transparent',
              backgroundColor: activeSection === section.id ? `${currentColors.primary}10` : 'transparent',
              color: activeSection === section.id ? currentColors.primary : currentColors.text
            }}
          >
            <Icon name={section.icon} size={16} />
            {section.label}
          </button>
        ))}
      </div>

      {/* Section Content */}
      {activeSection === 'vision' && renderVisionDocument()}
      {activeSection === 'consultation' && renderConsultation()}
      {activeSection === 'company-info' && renderCompanyInfo()}
    </div>
  );
};

export default AboutContentManagement;
